export default "__VITE_ASSET__Dy$VJpCr__"